import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { GlobalService } from "../global-service";
import { MessageService } from "primeng/api";
@Component({
  selector: "app-news",
  templateUrl: "./news.component.html",
  styleUrls: ["./news.component.css"],
})
export class NewsComponent implements OnInit {
  news: any = [];
  constructor(
    private router: Router,
    public global: GlobalService,
    private route: ActivatedRoute,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.getDetails();
  }

  getDetails() {
    const url = this.global.basePath + "news";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.data;
      this.news = data;
    });
  }

  newsDetails(id: any) {
    this.router.navigateByUrl("news-detail/" + id);
  }
}
